import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-blogs-create',
  templateUrl: './blogs-create.component.html',
  styleUrls: ['./blogs-create.component.scss']
})
export class BlogsCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  public course = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
       console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/blogsbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              title: data.data.title,
              image: data.data.image,
              description: data.data.description,
              url: data.data.url,
              h1_tag_content: data.data.h1_tag_content,
              meta_title: data.data.meta_title,
              meta_keyword: data.data.meta_keyword,
              meta_description: data.data.meta_description,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.Form = this.formBuilder.group({
      title: ['', Validators.required],
      image: ['', Validators.required],
      description: ['', Validators.required],
      url: ['', Validators.required],
      h1_tag_content: ['', Validators.required],
      meta_title: ['', Validators.required],
      meta_keyword: ['', Validators.required],
      meta_description: ['', Validators.required],
      _id: ['']
    })
  }

  modifyUrl()
  {
   this.Form.patchValue({
     content_url: this.Form.value.content_url.toLowerCase().replace(/ /g, '-')
   })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }
console.log(this.action)
    if(this.action == 'Submit'){
    
    var data = {
      "title" : this.Form.value.title,
      "image": this.Form.value.image,
      "description": this.Form.value.description,
      "admin" : sessionStorage.getItem('adminName'),
      "h1_tag_content": this.Form.value.h1_tag_content,
      "meta_title": this.Form.value.meta_title,
      "meta_keyword": this.Form.value.meta_keyword,
      "meta_description": this.Form.value.meta_description,
      "url" : this.Form.value.url,
    };
    console.log(data);
    console.log(this.api_endpoint);
    this.http.post<any>(this.api_endpoint+'/blogs', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
       this.router.navigateByUrl('/adminhkbkcms/blogs/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
  }else{
    var data1 = {
      "title" : this.Form.value.title,
      "image": this.Form.value.image,
      "description": this.Form.value.description,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
      "h1_tag_content": this.Form.value.h1_tag_content,
      "meta_title": this.Form.value.meta_title,
      "meta_keyword": this.Form.value.meta_keyword,
      "meta_description": this.Form.value.meta_description,
      "url" : this.Form.value.url,
    };
       console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/blogs/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/blogs/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }


}
